import { clipFor, posterFor } from "@/lib/journey";

// Adversity scene dissolves into the Change scene as Rich's words land.
export const CinematicScene = ({ adversityScene, changeScene, changeOpacity }) => (
  <div className="absolute inset-0">
    <video
      src={clipFor(adversityScene)}
      poster={posterFor(adversityScene)}
      autoPlay muted loop playsInline
      className="w-full h-full object-cover"
      data-testid="cinematic-backdrop"
    />
    <video
      src={clipFor(changeScene)}
      poster={posterFor(changeScene)}
      autoPlay muted loop playsInline
      className="absolute inset-0 w-full h-full object-cover"
      style={{ opacity: changeOpacity, transition: "opacity 1.6s linear" }}
      data-testid="cinematic-backdrop-change"
      data-opacity={changeOpacity.toFixed(2)}
    />
    <div className="absolute inset-0 bg-gradient-to-b from-[#FAF7F2]/80 via-[#FAF7F2]/88 to-[#FAF7F2]" />
    <div className="absolute inset-0 bg-gradient-to-r from-[#FAF7F2]/50 via-transparent to-[#FAF7F2]/50" />
  </div>
);
